import { Injectable, Injector, Inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { ToastComponent } from './toast.component';
import { ToastData, IToastData } from './toast-data';
import { ToastRef } from './toast-ref';
import { defaultToastConfig } from './toast-config';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private lastToast: ToastRef;
    private toastConfig = defaultToastConfig;

    constructor(
        private overlay: Overlay,
        private parentInjector: Injector,
    ) { }

    show(data: IToastData) {
        const positionStrategy = this.getPositionStrategy();
        const overlayRef = this.overlay.create({ positionStrategy });

        const toastRef = new ToastRef(overlayRef);
        this.lastToast = toastRef;

        const injector = this.getInjector(data, toastRef, this.parentInjector);
        const toastPortal = new ComponentPortal(ToastComponent, null, injector);

        overlayRef.attach(toastPortal);

        return toastRef;
    }

    getPositionStrategy() {
        return this.overlay.position()
            .global()
            .top(this.getPosition())
            .right(this.toastConfig.position.right + 'px');
    }

    getPosition() {
        const lastToastIsVisible = this.lastToast && this.lastToast.isVisible();

        const position = lastToastIsVisible
            ? this.lastToast.getPosition().bottom
            : this.toastConfig.position.top;

        return position + 'px';
    }

    getInjector(data: IToastData, toastRef: ToastRef, parentInjector: Injector) {
        const tokens = new WeakMap();
        const toastData = new ToastData(data);

        tokens.set(ToastData, toastData);
        tokens.set(ToastRef, toastRef);

        return new PortalInjector(parentInjector, tokens);
    }
}
